if (!window.Maximize.loadedScript.includes('postal-catalog-map.js')) {
  window.Maximize.loadedScript.push('postal-catalog-map.js');

  const DEFAULT_CATALOG = 'catalog_gta';

  window.Maximize.postalCatalog = {
    map: null,
    defaultCatalog: DEFAULT_CATALOG,
    _loadPromise: null,

    load() {
      if (this._loadPromise) return this._loadPromise;

      const url = window.Maximize.postalCatalogMapUrl;
      if (!url) {
        this._loadPromise = Promise.resolve({});
        return this._loadPromise;
      }

      this._loadPromise = fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(`Postal catalog map failed: ${res.status}`);
          return res.json();
        })
        .then((map) => {
          this.map = map;
          console.log('postal-catalog-map', this.map);
          document.dispatchEvent(
            new CustomEvent('postal-catalog:loaded', { detail: { map } })
          );
          return map;
        })
        .catch((err) => {
          console.error('[postal-catalog-map]', err);
          this.map = {};
          return this.map;
        });

      return this._loadPromise;
    },

    normalizePostal(postal) {
      return String(postal || '')
        .toUpperCase()
        .replace(/\s+/g, '');
    },

    fsaFromPostal(postal) {
      return this.normalizePostal(postal).slice(0, 3);
    },

    resolve(postal) {
      const fsa = this.fsaFromPostal(postal);
      if (!fsa || !this.map) return this.defaultCatalog;
      return this.map[fsa] || this.defaultCatalog;
    },
  };

  window.Maximize.postalCatalog.load();
}
